/**
 * 全局指令注册
 * @author 系统
 * @date 2024-01-01
 */

import type { App } from 'vue'
import { setupPermissionDirectives } from './permission'
import { copy } from './copy'
import { debounceDirective } from './debounce'
import { throttleDirective } from './throttle'
import { setupModulePermissionDirectives } from './module-permission'

/**
 * 注册全局指令
 * @param app Vue应用实例
 */
export const setupGlobalDirectives = (app: App) => {
  if ((app.config.globalProperties as any).__directivesInstalled) {
    return
  }
  ;(app.config.globalProperties as any).__directivesInstalled = true
  // 注册权限指令
  setupPermissionDirectives(app)

  // 注册模块配置系统权限指令
  setupModulePermissionDirectives(app)

  // 复制指令
  app.directive('copy', copy)

  // 防抖指令
  app.directive('debounce', debounceDirective)

  // 节流指令
  app.directive('throttle', throttleDirective)
}

// 导出所有指令
export {
  copy,
  debounceDirective as debounce,
  throttleDirective as throttle
}
